import { useState, useEffect } from 'react';
import { atom, useAtom } from'jotai';
import styled from '@emotion/styled';
import NoLogInPageWeb from 'components/layout/NoLogOutPageWeb';

import { Button, Toast } from 'components/ui';

import PhotoContainer from './PhotoContainer';
import ConfirmationModal from "./Modal/ComfirmModal";
import { selectedImagesAtom } from 'components/pages/Onboarding/onboardingAtom';
import ReactGA from "react-ga4";

const showModalAtom = atom<boolean>(false); //전송 확인 모달창 열림 여부 상태

const Elem:React.FC<any> = ({ children }) => {
  const [ selectedImage, setSelectedImage ] = useAtom(selectedImagesAtom);
  const [ toastMessage, settoastMessage ]   = useState<string>("");
  const [ isToastOpen, setIsToastOpen ]     = useState<boolean>(false);
  const [ showModal, setShowModal ]         = useAtom(showModalAtom);

  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  useEffect(() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/onboarding/1/freekit", title: "send free kit" })
    }
  },[])
  
  useEffect(() => {
    handleToast()
  }, [selectedImage]);

  const handleToast = () => {
    if (selectedImage.length < 5) {
      settoastMessage("5장의 사진을 모두 채워주세요!");
      setIsToastOpen(true);
    } else if (selectedImage.length > 5) {
      settoastMessage("초과된 사진은 자동으로 제외했어요!");
      setIsToastOpen(true);
    } else {
      settoastMessage("5장을 선택했어요!");
      setIsToastOpen(true);
    } 
  };

  const closeModal = () => {
    if (showModal === true) return setShowModal(false);
    ReactGA.event({
      "category": "Modal",
      "action" : "Close",
      "label"  : "photo confirm Modal"
    })
  };

  const handleCloasToast = () => {
    setIsToastOpen(false);
  };

  const handleResponse = () => {
    if (selectedImage.length >=5) {
      ReactGA.event({
        category : "Button",
        action : "Open",
        label : "photo confirm Modal",
        value: 1
      })
      setShowModal(true);
    } else {
      ReactGA.event({
        category : "Button",
        action : "Open",
        label : "photo confirm Modal",
        value: 2
      })
      settoastMessage("사진을 먼저 추가하세요!");
      setIsToastOpen(true);
    }
  };

  useEffect(() => {
    setIsToastOpen(false)
  }, [])

  return (
    <NoLogInPageWeb disable={false}>
      <Container>
        <BaseContainer>
          <TextContainer>
            <SmallText>간편하게 시작하세요</SmallText>
            <BigText className="Top">무료 체험 인화할</BigText>
            <BigText className="Bottom">5장을 선택해 주세요.</BigText>
            <SmallText className="small">체험 후에도 언제든 해지할 수 있어요.</SmallText>
            <SmallText className="small">부담없이 받아보고 결정하세요.</SmallText>
          </TextContainer>
          <PhotoSelectContainer>
            <PhotoContainer />
          </PhotoSelectContainer>
          <ToastContainser>
            {isToastOpen && 
              <Toast 
                message={toastMessage}
                onClose={handleCloasToast}
              />}
          </ToastContainser>
          <ButtonWrapper>
            <Button
              layoutVariant="contained"
              variant="default"
              onClick={handleResponse}
              expand
            >
            무료 인화 신청
            </Button>
            {showModal && <ConfirmationModal showModal={showModal} closeModal={closeModal} />}
          </ButtonWrapper>
        </BaseContainer>
      </Container>
    </NoLogInPageWeb>
  );
};

export default Elem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 24px 17px;
`;
const TextContainer = styled.div`
  width: 267px;
  height: 87px;
  display: flex;
  flex-direction: column;
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 100%;
  color: #141414;
  margin-bottom: 16px;

  &.small{
    font-size: 12px;
    font-weight: 300;
    margin-top: 16px;
    margin-bottom: 0;
    line-height: 3%;
    color: rgba(117, 117, 117, 1);
  }
`;
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  line-height: 100%;
  color: #141414;

  &.Top {
    font-weight: lighter;
    margin-bottom: 5px;
  }

  &.Bottom {
    font-weight: Bold;
  }
`;
const PhotoSelectContainer = styled.div`
  width: 100%;
  /* height: 261px; */
  min-height: 300px;
  margin: 67px auto 0;
`;
const ButtonWrapper =styled.div`
  width: 300px;
  height: 52px;
  margin: 5px auto 0;
`;
const ToastContainser = styled.div`
  width: 300px;
  height: 43px;
  /* margin: 80px auto 0; */
  margin: 30px auto 0;
`;
const BaseContainer = styled.div`
  max-width: 344px;
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 40px auto;
`;